
import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiBroeuklenSchipholPage() {
  return (
    <CityAirportTemplate
      city="Breukelen"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={50.00}
      distance="40 km"
      duration="30-35 minuten"
    />
  );
}
